(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Table4JS", [], factory);
	else if(typeof exports === 'object')
		exports["Table4JS"] = factory();
	else
		root["Table4JS"] = factory();
})(self, () => {
return 